<template>
  <transition name="fade">
    <v-card rounded="xl" class="pa-4 mb-4">
      <v-form @submit.prevent="checkForm">
        <v-text-field
          v-model="nombre"
          label="Nombre de la agencia"
          :error-messages="errors.nombre"
          @change="getEpHotel"
          required
        ></v-text-field>

        <v-switch
          v-if="false"
          v-model="defaultColor"
          label="Color por default"
        ></v-switch>
        <v-color-picker
          v-if="!defaultColor"
          v-model="AvaiColor"
          mode="hexa"
          hide-canvas
          label="Color etiqueta"
        ></v-color-picker>

        <v-checkbox
          v-if="false"
          v-model="transportacionActivada"
          label="Administrar precios de transportación"
        ></v-checkbox>

        <v-container v-if="transportacionActivada">
          <v-select
            v-model="epHotelId"
            :items="hotelesEP"
            item-value="Id"
            item-text="label"
            label="Ubicación de hotel"
            dense
          ></v-select>

          <v-text-field
            v-model.number="PrecioRT"
            label="Precio RoundTrip (USD)"
            type="number"
          ></v-text-field>
          <v-text-field
            v-model.number="PrecioOWHG"
            label="Precio One Way (Hotel -> Campo) (USD)"
            type="number"
          ></v-text-field>
          <v-text-field
            v-model.number="PrecioOWGH"
            label="Precio One Way (Campo -> Hotel) (USD)"
            type="number"
          ></v-text-field>
        </v-container>

        <v-container v-if="transportacionActivada">
          <v-text-field
            v-model.number="duracion.horas"
            label="Horas"
            type="number"
            min="0"
            required
          ></v-text-field>
          <v-text-field
            v-model.number="duracion.minutos"
            label="Minutos"
            type="number"
            min="0"
            max="60"
            required
          ></v-text-field>
        </v-container>

        <v-row justify="end">
          <v-btn class="mr-2" @click="$emit('toggle', false)"
            >Cancelar</v-btn
          >
          <v-btn color="success" type="submit">Guardar</v-btn>
        </v-row>
      </v-form>
    </v-card>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-card {
  width: 100%;
}
</style>

<script>
import axiosCore from "axios";

export default {
  name: "addMayoristaForm",
  components: {},
  props: ["temporadas"],
  data() {
    return {
      nombre: "",
      codigo: "",
      ruta: "",
      transportacionActivada: false,
      epHotelId: "",
      PrecioRT: "",
      PrecioOWGH: "",
      PrecioOWHG: "",
      defaultColor: true,
      AvaiColor: "",
      duracion: { horas: 0, minutos: 0 },
      errors: [],
      hotelesEP: [],
    };
  },
  methods: {
    async getEpHotel() {
      let axiosInstance = axiosCore.create({
        headers: {
          "Content-Type": "text/plain",
        },
        transformRequest: (data) => {
          return JSON.stringify(data);
        },
      });
      let urlEp =
        "https://www.entertainment-plus.net/get_hotels_deeplink?term=" +
        this.nombre;
      this.$pgsHelper.log(urlEp);
      const response = await axiosInstance.get(urlEp);
      this.hotelesEP = response.data;
    },

    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre de la Agencia es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (this.transportacionActivada == true) {
        if (this.duracion.horas === "" || this.duracion.minutos === "") {
          this.errors.duracion = "Proporciona una duración valida";
          valid = false;
        } else {
          this.errors.duracion = false;
        }

        if (
          this.PrecioRT === "" ||
          this.PrecioOWGH === "" ||
          this.PrecioOWHG === ""
        ) {
          this.errors.duracion = "Proporciona precios validos";
          valid = false;
        } else {
          this.errors.duracion = false;
        }
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        this.$emit("successData", this.$data);
      }
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.getEpHotel();
  },
};
</script>
